import { render, staticRenderFns } from "./PmdaCompanyPopup.vue?vue&type=template&id=15461bde&"
import script from "./PmdaCompanyPopup.vue?vue&type=script&lang=js&"
export * from "./PmdaCompanyPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports